import { LockSettingFields, LockSettingTypeList, NameViewMode, isSettingLocked } from "./v3/schema/settings.js";
import { toSavedColumnOrder } from "./v3/parser/settings.js";
import { pick } from "es-toolkit";
//#region ../erd-editor-schema/dist/normalizeSettings.js
function normalizeSettings(source) {
	const { lockedValues, lockSettings, ddlScripts, nameViewMode, ...rest } = source;
	const settings = {
		...rest,
		columnOrder: toSavedColumnOrder(rest.columnOrder),
		lockSettings,
		...ddlScripts && (ddlScripts.before !== "" || ddlScripts.after !== "") ? { ddlScripts: {
			before: ddlScripts.before,
			after: ddlScripts.after
		} } : {},
		...nameViewMode === void 0 ? {} : { nameViewMode }
	};
	LockSettingTypeList.forEach((lockSettingType) => {
		if (lockedValues && isSettingLocked(lockSettings, lockSettingType)) Object.assign(settings, pick(lockedValues, LockSettingFields[lockSettingType]));
	});
	if (settings.nameViewMode === NameViewMode.physical) delete settings.nameViewMode;
	return settings;
}
//#endregion
export { normalizeSettings };
